import { useEffect } from "react";
import { isDev } from "../../../base/index.js";
const emptyObject = {};
function useFormVerboseMode(formName, verbose, formApi) {
  useEffect(() => {
    if (verbose === "verbose" && !isDev()) {
      console.warn(
        `[${formName}] You are enabling Form Verbose Mode in a non-Production environment. Consider disabling it.`
      );
    }
    formApi.setDebugMode(verbose);
  }, [formApi, verbose, formName]);
}
export {
  useFormVerboseMode
};
//# sourceMappingURL=useFormVerboseMode.js.map
